export default __webpack_public_path__ + "static/media/about.f2106759.png";